import {
  _app_quality_application_name,
  _app_quality_audit_log,
  _app_quality_bi,
  _app_quality_comments,
  _app_quality_db_size,
  _app_quality_expansion,
  _app_quality_frequency,
  _app_quality_growth,
  _app_quality_maintenance,
  _app_quality_outage_impact,
  _app_quality_redundancy,
  _app_quality_revenue,
  _app_quality_sole_source,
  _app_quality_stability,
  _app_quality_total_size,
  _app_quality_training,
  _app_quality_uniqueness,
  _app_quality_value,
  _id
} from './assets';

// ----------------------------------------------------------------------

export const _app_quality = {
  id: (index: number) => _id[index],
  // Projects
  application_name: (index: number) => _app_quality_application_name[index],
  db_size: (index: number) => _app_quality_db_size[index],
  total_size: (index: number) => _app_quality_total_size[index],
  audit_log: (index: number) => _app_quality_audit_log[index],
  comments: (index: number) => _app_quality_comments[index],
  // Usefulness
  frequency: (index: number) => _app_quality_frequency[index],
  expansion: (index: number) => _app_quality_expansion[index],
  training: (index: number) => _app_quality_training[index],
  bi: (index: number) => _app_quality_bi[index],
  revenue: (index: number) => _app_quality_revenue[index],
  growth: (index: number) => _app_quality_growth[index],
  uniqueness: (index: number) => _app_quality_uniqueness[index],
  // Bussiness Risks
  stability: (index: number) => _app_quality_stability[index],
  maintenance: (index: number) => _app_quality_maintenance[index],
  outage_impact: (index: number) => _app_quality_outage_impact[index],
  value: (index: number) => _app_quality_value[index],
  sole_source: (index: number) => _app_quality_sole_source[index],
  redundancy: (index: number) => _app_quality_redundancy[index]
};
